import { render } from "./EditLeaveType.vue?vue&type=template&id=6542d0a7&scoped=true"
import script from "./EditLeaveType.vue?vue&type=script&lang=js"
export * from "./EditLeaveType.vue?vue&type=script&lang=js"

import "./leave-type.scss?vue&type=style&index=0&id=6542d0a7&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6542d0a7"]])

export default __exports__